const RegisterPage = () => {

    return (
        <h1>Rejestracja</h1>
    )
}

export default RegisterPage;
